import * as types from '../actions';

const initialState = {
    items: [],
    status:0,
    totalPage:0,
    numRows:0,
    count:'',
    item:{
        id:'',
        companyName:'',
        websiteUrl:'',
        companyContactNum:'',
        companyEmail:'',
        companyRegNum:'',
        vatNum:'',
        vatTax:'',
        sector:0,
        subSector:0,    
        logo:'',
        location:'',
        googleLocation:'',
        streetOne:'',
        streetTwo:'',
        city:'',
        state:'',
        country:'',
        postcode:'',
        prmyCnctAssUserId:'',
        prmyCnctUserId:'',
        emailVerify:true,
        firstName:'',
        lastName:'',
        contactNumber:'',
        emailAddress:'',  
        position:'',
        distanceUnit:'',
        currency:'',
        quoteValidity:'',
        minDistance:'',
        crewCountChief:'',
        rate:'',
        crewChiefPayRate:'',
        crewChiefChargeRate:'',
        appCommision:'',
        poolCommision:'',
        additionalText:'',
        isPrmCnctList:false,   
        startTime:'',   
        timeAllowedTime:'',   
        checkoutTime:'',   
        supervisorName:'',
        staffName:'',
        minShiftLength:'',               
        mutePushs:true,                  
        muteMails:true,
        muteClientEmails: true,   
        isPrimaryUserLogin: false, 
        travelSettings: {}, 
        minimumTravelDistance: 0,
        travelModuleMasterFields: [],
    },
    sectors:[],  
    subSectors:[], 
    activity:'',
    locations:[],
    currency:[],
    prmryUsers:[],
    errorData:'',
};

export default function(state = initialState, action) {
    const response = action.response;
    let timeVar = '~~'+Date.now(); 
    switch(action.type) {

        case types.SECTOR_ALL_SUPERADMIN_LIST_SUCCESS:
            return {
                ...state,
                sectors:response.data,
                status: response.status,  
                activity:types.SECTOR_ALL_SUPERADMIN_LIST_SUCCESS,                               

            };
        case types.SUBSECTOR_ALL_LIST_SUPERADMIN_SUCCESS:
            return {
                ...state,
                subSectors:response.data,
                status: response.status,   
                activity:types.SUBSECTOR_ALL_LIST_SUPERADMIN_SUCCESS,                              

            };
        case types.AFFILIATES_LIST_SUCCESS:
            if(response.status===200){
                let totalPage = Math.ceil(response.data.count/response.data.page_size);
                return {
                    ...state,
                    items: response.data.results,
                    status: response.status,
                    activity:types.AFFILIATES_LIST_SUCCESS,
                    totalPage: totalPage,
                    numRows:response.data.results.length,
                    count:response.data.count                  
                };
            }else{
                return {
                    ...state,
                    status: response.status, 
                    activity:types.AFFILIATES_LIST_ERROR,                                
                };
            }
        case types.AFFILIATE_COMPANYINFO_ADD_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    item:{
                        id:response.data.id,
                        companyName:response.data.company_name,
                        websiteUrl:response.data.web_site,
                        companyContactNum:response.data.phone_number,
                        companyEmail:response.data.company_email,
                        companyRegNum:response.data.company_reg_no,
                        vatNum:response.data.vat_number,
                        vatTax:response.data.vat,
                        sector:(response.data.sector)?response.data.sector.id:0,
                        subSector:(response.data.sub_sector)?response.data.sub_sector.id:0
                    },
                    status: response.status,
                    activity:types.AFFILIATE_COMPANYINFO_ADD_SUCCESS,
                }
            }else{
                return {
                    ...state,
                    status: response.status,
                    activity:types.AFFILIATE_COMPANYINFO_ADD_ERROR,
                    errorData:response.data
                }
            }
        
        case types.AFFILIATE_EDIT_SUCCESS:

            if(response.status===200){

                let lnVenue         = '';
                let lnStreetOne     = null;
                let lnStreetTwo     = null;
                let lnCity          = null;
                let lnState         = null;
                let lnCountry       = null;
                let lnPostcode      = null;
                let pcFirstName     = null;
                let pcLastName      = null;
                let pcContactNum    = null;
                let pcEmail         = null;
                let pcPosition      = '';
                let currency        = '';
                let pcPrmCnctList   = false;
                let pcAssUserId     = '';
                let pcUserId        = '';
                let pcEmailVerify   = true;
                let mutePushs       = true;
                let muteMails       = true;
                

                if(response.data.location!==null){
                    lnVenue      = response.data.location.venue;
                    lnStreetOne  = response.data.location.street1;
                    lnStreetTwo  = response.data.location.street2;
                    lnCity       = response.data.location.city;
                    lnState      = response.data.location.state;
                    lnCountry    = response.data.location.country;
                    lnPostcode   = response.data.location.postcode;
                }
                if(response.data.associateusers_set.length>0){  
                    let filtered = response.data.associateusers_set.filter(function (el) {
                        return el != null;
                    }); 
                    pcFirstName   = filtered[0].user.first_name;
                    pcLastName    = filtered[0].user.last_name;
                    pcContactNum  = filtered[0].phone_number;
                    pcEmail       = filtered[0].user.email;
                    pcPosition    = filtered[0].position;
                    pcPrmCnctList = true;
                    pcAssUserId   = filtered[0].id;
                    pcUserId      = filtered[0].user.id;
                    pcEmailVerify = filtered[0].email_verified;
                    mutePushs     = filtered[0].mute_pushs;
                    muteMails     = filtered[0].mute_mails;
                }
                if(response.data.currency!==null){
                    currency = response.data.currency.id;
                }

                // crewChiefPayRate:response.data.crew_chief_pay_bonus?response.data.crew_chief_pay_bonus:0,
                // crewChiefChargeRate:response.data.crew_chief_bonus,
                return {
                    ...state,
                    item:{
                        id:response.data.id,
                        companyName:response.data.company_name,
                        websiteUrl:response.data.web_site,
                        companyContactNum:response.data.phone_number,
                        companyEmail:response.data.company_email,
                        companyRegNum:response.data.company_reg_no,
                        vatNum:response.data.vat_number,
                        vatTax:response.data.vat,
                        sector:(response.data.sector)?response.data.sector.id:0,
                        subSector:(response.data.sub_sector)?response.data.sub_sector.id:0, 
                        logo:response.data.logo,
                        location:'',
                        googleLocation:'',
                        venue: lnVenue,
                        streetOne:lnStreetOne,
                        streetTwo:lnStreetTwo,
                        city:lnCity,
                        state:lnState,
                        country:lnCountry,
                        postcode:lnPostcode,
                        firstName:pcFirstName,
                        lastName:pcLastName,
                        contactNumber:pcContactNum,
                        emailAddress:pcEmail, 
                        position:pcPosition,
                        isPrmCnctList:pcPrmCnctList,
                        prmyCnctAssUserId:pcAssUserId,
                        prmyCnctUserId:pcUserId,  
                        emailVerify:pcEmailVerify,                                           
                        distanceUnit:response.data.distance_unit,
                        currency:currency,
                        quoteValidity:response.data.quote_validity,
                        minDistance:response.data.minimum_distance,
                        crewCountChief:response.data.crew_count_chief,
                        rate:response.data.unit_rate,
                        appCommision:response.data.app_commission,
                        poolCommision:response.data.pool_commision,
                        additionalText:response.data.additional_text===null?'':response.data.additional_text, 
                        dynamic_fields:response.data.dynamic_fields,  
                        timeZone:response.data.region_time_zone,                   
                        startTime:response.data.start_time,                  
                        timeAllowedTime:response.data.timesheet_allowed_time,                  
                        checkoutTime:response.data.checkout_time,                  
                        supervisorName:response.data.supervisor_name,
                        staffName:response.data.staff_name,
                        minShiftLength:response.data.min_shift_length,                 
                        mutePushs:mutePushs,                  
                        muteMails:muteMails,
                        muteClientEmails:response.data.mute_client_emails,   
                        isPrimaryUserLogin: response.data?.is_primary_user_login ? response.data.is_primary_user_login : false, 
                        travelSettings: response.data?.travel_settings ? response.data.travel_settings : {}, 
                        travelModuleMasterFields: response.data?.travel_module_master_fields ? response.data.travel_module_master_fields : [],
                    },
                    status: response.status,
                    activity:types.AFFILIATE_EDIT_SUCCESS, 
                }    
            }else{
                return {
                    ...state,
                    status:response.status,
                    activity:types.AFFILIATE_EDIT_ERROR,
                } 
            }

        case types.AFFILIATE_CMPNY_INFO_UPDATE_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    status:response.status,
                    activity:types.AFFILIATE_CMPNY_INFO_UPDATE_SUCCESS,
                    affiliateUpdatedData:response.data
                } 
            }else{
                return {
                    ...state,
                    status:response.status,
                    activity:types.AFFILIATE_CMPNY_INFO_UPDATE_ERROR,
                    errorData:response.data
                } 
            }
        case types.AFFILIATE_ADDRESS_UPDATE_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    status:response.status,
                    activity:types.AFFILIATE_ADDRESS_UPDATE_SUCCESS,
                } 
            }else{
                return {
                    ...state,
                    status:response.status,
                    activity:types.AFFILIATE_ADDRESS_UPDATE_ERROR,
                    errorData:response.data
                } 
            } 
        case types.AFFILIATE_PRMRY_CNT_UPDATE_SUCCESS:
            if(response.status===200){
                let activity = types.AFFILIATE_PRMRY_CNT_UPDATE_SUCCESS;
                if(response.data.hasOwnProperty("user_id")){
                    activity = types.AFFILIATE_PRMRY_CNT_ADD_SUCCESS;
                }
                return {
                    ...state,
                    status:response.status,
                    activity:activity,
                }
            }else{
                return {
                    ...state,
                    status:response.status,
                    activity:types.AFFILIATE_PRMRY_CNT_UPDATE_ERROR,
                    errorData:response.data
                }
            }
        case types.AFFILIATE_SETTINGS_UPDATE_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    status:response.status,
                    activity:types.AFFILIATE_SETTINGS_UPDATE_SUCCESS,
                }
            }else{
                return {
                    ...state,
                    status:response.status,
                    activity:types.AFFILIATE_SETTINGS_UPDATE_ERROR,
                    errorData:response.data
                }
            }
        case types.AFFILIATE_DELETE_SUCCESS:
            const id = response.data.id; 
            if(response.status===200){
                return {
                    ...state,
                    items: state.items.filter(items => items.id !== id),
                    status:response.status,
                    activity:types.AFFILIATE_DELETE_SUCCESS,
                }     
            }else{
                return {
                    ...state,
                    status:response.status,
                    activity:types.AFFILIATE_DELETE_ERROR,
                    errorData: response.data,
                }     
            }
               
        case types.MASTER_LOCATION_LIST_SUCCESS:
            return {
                ...state,
                status:response.status,
                locations:response.data,
                activity:types.MASTER_LOCATION_LIST_SUCCESS,
            }            

        case types.LIST_CURRENCY_SUCCESS:
            return {
                ...state,
                status:response.status,
                currency:response.data,
                activity:types.LIST_CURRENCY_SUCCESS,
            } 
        case types.LIST_PRMY_CNCT_SUCCESS:
            return {
                ...state,
                status:response.status,
                prmryUsers:response.data.data,
                activity:types.LIST_PRMY_CNCT_SUCCESS,
            } 
        case types.RESEND_EMAIL_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    status:response.status,
                    activity:types.RESEND_EMAIL_SUCCESS,
                } 
            }else{
                return {
                    ...state,
                    status:response.status,
                    activity:types.RESEND_EMAIL_ERROR,
                    errorData: response.data,
                } 
            }  

        case types.CLEAR:
            return {
                ...state,
                status:0,
                activity:types.CLEAR
            } 
       
        default:
            return state;
    }
};